import { Icon } from "@mui/material";

function IconDisplay({name}){
    return <Icon>{name}</Icon>
}

export default IconDisplay;